/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cv_Extract_Form_Enum_Bachelor8Inputs */

const en_cv_extract_form_enum_bachelor8 = /** @type {(inputs: Cv_Extract_Form_Enum_Bachelor8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bachelor`)
};

const de_cv_extract_form_enum_bachelor8 = /** @type {(inputs: Cv_Extract_Form_Enum_Bachelor8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bachelor`)
};

/**
* | output |
* | --- |
* | "Bachelor" |
*
* @param {Cv_Extract_Form_Enum_Bachelor8Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const cv_extract_form_enum_bachelor8 = /** @type {((inputs?: Cv_Extract_Form_Enum_Bachelor8Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cv_Extract_Form_Enum_Bachelor8Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_cv_extract_form_enum_bachelor8(inputs)
	return en_cv_extract_form_enum_bachelor8(inputs)
});
export { cv_extract_form_enum_bachelor8 as "cv_extract_form_enum_BACHELOR" }